import GetITBAxiosInstance from "src/data-access/axios-instance-creator";
import { IAuthDTO, ITempAuthDTO } from "./models/response/auth";
import { IVEAnalysis_SharedTableDTO, IVEAnalysis_DocumentDTO, IVEAnalysis_VCModificationLogDTO, IVEAnalysis_SharedMatricsDTO } from "./models/response/ve-analysis";
import { IValueCalculatorDataDTO } from "./models/response/bbtable";
import { IChangeStatusRM, IClientRM, IDownloadClientsRM, IListClientsRM } from "./models/request/client";
import { ICreateAssignSolutionUserRM, IRevokeSolutionAccessRM, IRejectRequestsRM } from "./models/request/solution-user";
import { IPendingRequestSolutionUserDTO, IManageUserDTO, IExistingUserWithSolutionRoleDTO, ISolutionRoleDTO } from "./models/response/solution-user";
import { ICreateUpdateSolutionRM, IActivateDeactivateSolutionRM } from "./models/request/solution";
import { IChangeSolutionStatusRM, ICreateSolutionRM, ISolutionStep1_1, ISolutionStep1_2, ISolutionStep1_3, ISolutionStep2, ISolutionStep3, ISolutionStep4, ISolutionStep5 } from "./models/request/solution_new";
import { IChangePasswordRM, ICreateITBAdminRM, IForgotPasswordRM, ILoginRM, IResetPasswordRM, ISelfRegisterSolutionUserRM, IUpdateITBAdminRM, IUserDTO, ITerminateUserRM } from "./models/request/user-auth";
import {
    API_ROUTE_SIGNIN,
    API_ROUTE_CREATE_ITB_ADMIN,
    API_ROUTE_CHNAGE_PASSWORD,
    API_ROUTE_FORGOT_PASSWORD,
    API_ROUTE_RESET_PASSWORD,
    API_ROUTE_SELF_REGISTER_VERIFYEMAIL_SEND_OTP,
    API_ROUTE_SELF_REGISTER_VERIFYEMAIL_RESEND_OTP,
    API_ROUTE_SELF_REGISTER_VERIFYEMAIL_BY_OTP,
    API_ROUTE_LIST_VE_ANALYSIS,
    API_ROUTE_LIST_VE_RECENT_ANALYSIS,
    API_ROUTE_ARCHIVE_VE_ANALYSIS,
    API_ROUTE_GET_VE_ANALYSIS_BY_ID,
    API_ROUTE_VE_ANALYSIS_CREATE_UPDATE,
    API_ROUTE_VE_ANALYSIS_WRITE_DATAPOINT,
    API_ROUTE_VE_ANALYSIS_BASIC_SETUP,
    API_ROUTE_VE_ANALYSIS_WRITE_TABLE,
    API_ROUTE_CLIENTS_IDNAMEDIC,
    API_ROUTE_CHANGE_CLIENT_STATUS,
    API_ROUTE_LIST_CLIENTS,
    API_ROUTE_CREATE_CLIENT,
    API_ROUTE_EXPORT_CLIENT,
    API_ROUTE_GET_CLIENT_BY_ID,
    API_ROUTE_CHECK_CLIENTNAME_EXIST,
    API_ROUTE_CHECK_CLIENTDOMAIN_EXIST,
    API_ROUTE_GET_PARTIALS_CLIENT_DETAILS,
    API_ROUTE_UPDATE_CLIENT,
    API_ROUTE_APPROVE_SOLUTION_REQUESTS,
    API_ROUTE_ASSIGN_SOLUTIONACCESSES_TO_EXISTING_SOLUTIONUSER,
    API_ROUTE_CREATE_SOLUTION_USER,
    API_ROUTE_GENERATE_SOLUTION_REQUESTS,
    API_ROUTE_LIST_PENDING_SOLUTION_REQUESTS,
    API_ROUTE_REJECT_SOLUTION_REQUESTS,
    API_ROUTE_REVOKE_SOLUTION_ACCESS,
    API_ROUTE_SELF_REGISTER_SOLUTIONUSER,
    API_ROUTE_SEND_REMINDERS_SIGNEDIN_ONLY_SOLUTIONUSERS,
    API_ROUTE_LIST_SOLUTIONACCESS,
    API_ROUTE_LIST_SOLUTIONADMINS,
    API_ROUTE_LIST_SOLUTIONUSER,
    API_ROUTE_LIST_SOLUTIONUSERROLES,
    API_ROUTE_LIST_SIGNEDIN_ONLY_SOLUTIONUSERS,
    API_ROUTE_TERMINATE_SOLUTIONUSER,
    API_ROUTE_CREATE_SOLUTION,
    API_ROUTE_CHECK_SOLUTIONNAME_EXISTS,
    API_ROUTE_LIST_SOLUTIONS_IDNAMEDIC_BY_CLIENTID,
    API_ROUTE_GET_SOLUTION_BY_ID,
    API_ROUTE_VALIDATE_VCEXCEL_FILE,
    API_ROUTE_LIST_ITB_ADMINS,
    API_ROUTE_CHECK_EMAIL_EXIST,
    API_ROUTE_GET_USER_BY_ID,
    API_ROUTE_UPDATE_PROFILE,
    API_ROUTE_GET_CURRENT_USER,
    API_ROUTE_VE_ANALYSIS_READ_OBJECTS,
    API_ROUTE_GET_ROLEBASE_SOLUTION_CONFIGURATIONS,
    API_ROUTE_VE_ANALYSIS_LOG_EVENT,
    API_ROUTE_UPDATE_ITB_ADMIN,
    API_ROUTE_LIST_VE_ANALYSIS_DOCS,
    API_ROUTE_VE_ANALYSIS_DOWNLOAD_DOCUMENT,
    API_ROUTE_SOLUTION_DOWNLOAD_DOCUMENT,
    API_ROUTE_SOLUTION_RESTORE,
    API_ROUTE_ACTIVATE_DEACTIVATED_SOLUTION,
    API_ROUTE_CHANGE_SOLUTION_STATUS,
    API_ROUTE_GET_SOLUTION_STEP_1_1,
    API_ROUTE_SAVE_SOLUTION_STEP_1_1,
    API_ROUTE_GET_SOLUTION_STEP_1_2,
    API_ROUTE_SAVE_SOLUTION_STEP_1_2,
    API_ROUTE_GET_SOLUTION_STEP_1_3,
    API_ROUTE_SAVE_SOLUTION_STEP_1_3,
    API_ROUTE_SAVE_SOLUTION_STEP_2,
    API_ROUTE_SAVE_SOLUTION_STEP_3,
    API_ROUTE_GET_SOLUTION_STEP_2,
    API_ROUTE_GET_SOLUTION_STEP_3,
    API_ROUTE_LIST_SUPPORTCASE,
    API_ROUTE_CREATE_SUPPORTCASE,
    API_ROUTE_UPDATE_SUPPORTCASE,
    API_ROUTE_RESOLVE_SUPPORTCASE,
    API_ROUTE_SUPPORT_CASE_DOWNLOAD_ATTACHMENT,
    API_ROUTE_EXPORT_SUPPORTCASE,
    API_ROUTE_TERMINATE_ITB_ADMIN,
    API_ROUTE_REACTIVE_ITB_ADMIN,
    API_ROUTE_SOLUTIONUSER_ACCESS_LIST,
    API_ROUTE_SOLUTIONUSER_ACCESS_MANAGE,
    API_ROUTE_LIST_OWN_SOLUTIONS,
    API_ROUTE_LIST_OTHERS_SOLUTIONS,
    API_ROUTE_LIST_ACTIVITY_HISTORY,
    API_ROUTE_LIST_CLIENT_DOCUMENTS,
    API_ROUTE_CREATE_CLIENT_DOCUMENTS,
    API_ROUTE_UPDATE_CLIENT_DOCUMENTS,
    API_ROUTE_LIST_CLIENT_DOCUMENT_CATEGORIES,
    API_ROUTE_SAVE_CLIENT_DOCUMENT_CATEGORIES,
    API_ROUTE_DELETE_CLIENT_DOCUMENTS,
    API_ROUTE_VE_ANALYSIS_CHANGE_STATUS,
    API_ROUTE_GET_SOLUTION_STEP_4,
    API_ROUTE_SAVE_SOLUTION_STEP_4,
    API_ROUTE_VE_DASHBOARD_USERS_COUNT,
    API_ROUTE_VE_DASHBOARD_ENGAGEMENT_ANALYTICS_COUNT,
    API_ROUTE_VE_DASHBOARD_USERS_VS_ANALYSIS_COUNT,
    API_ROUTE_VE_DASHBOARD_CHART_ANALYSIS_CREATED_BY_NEW_VS_RETURNING_USERS,
    API_ROUTE_VE_DASHBOARD_LIST_TOP_ACTIVE_USERS,
    API_ROUTE_VE_DASHBOARD_LIST_ANALYSIS,
    API_ROUTE_VE_DASHBOARD_REPORT_ANALYSIS,
    API_ROUTE_VE_ANALYSIS_LINK_SHARE_KEYINPUTS,
    API_ROUTE_VE_ANALYSIS_EXCEL_DOWNLOAD_KEYINPUTS,
    API_ROUTE_VE_ANALYSIS_EXCEL_UPLOAD_KEYINPUTS,
    API_ROUTE_SIGNIN_GUEST,
    API_ROUTE_VE_ANALYSIS_LIST_SHARED_KEYINPUT_STATUS as API_ROUTE_VE_ANALYSIS_LIST_SHARED_KEYINPUT_METRICS,
    API_ROUTE_VE_ANALYSIS_LIST_SHARED_KEYINPUTS,
    API_ROUTE_VE_ANALYSIS_WRITE_SHARED_KEYINPUTS,
    API_ROUTE_DOWNLOAD_CLIENT_DOCUMENT,
    API_ROUTE_LIST_PAGED_NOTIFICATIONS,
    API_ROUTE_VE_ANALYSIS_SAVE_CLIENT_PROVIDED_METRIC_INPUT,
    API_ROUTE_LIST_SALES_TRIGGER_NEWS,
    API_ROUTE_LIST_CI_ANALYSIS,
    API_ROUTE_CI_ANALYSIS_CREATE_UPDATE,
    API_ROUTE_GET_CI_ANALYSIS_BY_ID,
    API_ROUTE_LIST_ALL_SOLUTIONS,
    API_ROUTE_LIST_CI_COMPANY_TICKERS,
    API_ROUTE_SUMMARIZE_SALES_TRIGGER_NEWS,
    API_ROUTE_CI_ANALYSIS_GET_INDUSTRY_PEERS,
    API_ROUTE_CI_ANALYSIS_SAVE_INDUSTRY_PEERS,
    API_ROUTE_CI_ANALYSIS_GET_KYC_COMPANY_SNAPSHOT,
    API_ROUTE_CI_ANALYSIS_GET_KYC_PRIORITIES_INITIATIVES,
    API_ROUTE_CI_ANALYSIS_GET_KYC_CHALLENGES_RISKS,
    API_ROUTE_CI_ANALYSIS_GET_KYC_FINANCIALS,
    API_ROUTE_CI_ANALYSIS_GET_KYC_NEWS,
    API_ROUTE_CI_ANALYSIS_GET_ZOI_TRENDS,
    API_ROUTE_CI_ANALYSIS_GET_ZOI_COMPETITOR_INSIGHTS,
    API_ROUTE_CI_ANALYSIS_GET_ZOI_COMPANY_POSITION,
    API_ROUTE_CI_ANALYSIS_GET_BPS_PERSONA_ALIGNMENT,
    API_ROUTE_CI_ANALYSIS_GET_BPS_EXECUTIVE_SHAREHOLDER_SIGNALS,
    API_ROUTE_CI_ANALYSIS_GET_BPS_OPPORTUNITY_VS_ROADBLOCKS,
    API_ROUTE_CI_ANALYSIS_GET_BPS_SOLUTION_POSITIONING,
    API_ROUTE_GET_SOLUTION_STEP_5,
    API_ROUTE_SAVE_SOLUTION_STEP_5,
    API_ROUTE_VE_ANALYSIS_LINK_SHARE_WHOLE_ANALYSIS,
    API_ROUTE_VE_ANALYSIS_UPDATE_LINK_SHARE_WHOLE_ANALYSIS,
    API_ROUTE_VE_ANALYSIS_LIST_LINK_SHARES,
    API_ROUTE_VE_ANALYSIS_GET_LINK_SHARE,
    API_ROUTE_AI_GENERATE_TEXT,
    API_ROUTE_AI_GENERATE_CHAT_RESPONSE,
    API_ROUTE_VE_ANALYSIS_GET_VC_MODIFICATION_LOGS as API_ROUTE_VE_ANALYSIS_LIST_VC_MODIFICATION_LOGS,
    API_ROUTE_CI_ANALYSIS_GET_SHORT_INSIGHTS,
    API_ROUTE_CI_DASHBOARD_USERS_COUNT,
    API_ROUTE_CI_DASHBOARD_ENGAGEMENT_ANALYTICS_COUNT,
    API_ROUTE_CI_DASHBOARD_USERS_VS_ANALYSIS_COUNT,
    API_ROUTE_CI_DASHBOARD_CHART_ANALYSIS_CREATED_BY_NEW_VS_RETURNING_USERS,
    API_ROUTE_CI_DASHBOARD_LIST_TOP_ACTIVE_USERS,
    API_ROUTE_CI_DASHBOARD_LIST_ANALYSIS,
    API_ROUTE_CI_DASHBOARD_REPORT_ANALYSIS,
} from "./api-routes";
import { IPagedResultDTO } from "./models/response/paged";
import { IActivityHistoryDTO } from "./models/response/history";
import {
    IVEAnalysis_CreateUpdateRM,
    IVEAnalysis_BasicSetupRM,
    IVEAnalysis_ReadObjectsRM,
    IVEAnalysis_WriteTableRM,
    IVEAnalysis_WriteDataPointRM,
    IVEAnalysis_LogEventRM,
    IVEAnalysis_ChangeStatusRM,
    IVEAnalysis_LinkShareKeyInputsRM,
    IVEAnalysis_ExcelDownloadKeyInputsRM,
    IVEAnalysis_ExcelUploadKeyInputsRM,
    IVEAnalysis_WriteSharedKeyInputsRM,
    IVEAnalysis_SaveMetricBenchmarksRM,
    IVEAnalysis_LinkShareWholeAnalysisRM,
    IVEAnalysis_UpdateLinkShareWholeAnalysisRM,
    IValueEngineAnalysisLinkShareDTO,
    IVEAnalysis_ViewTableModificationLogsRM,
    IValueEngineAnalysisLinkShareResultDTO
} from "./models/request/ve-analysis";
import { IClientDTO } from "./models/response/client";
import { IRoleBasedSolutionConfigurationDTO, ISolutionDTO, IVCFileValidationResultDTO } from "./models/response/solution";
import { ISupportCaseDTO } from "./models/response/support-case";
import { IDownloadSuportCaseRM, IGenerateNewSupportCaseRM, IResolveSupportCaseRM, IUpdateSupportCaseRM } from "./models/request/support-case";
import { ISolutionAccessControl } from "./models/request/solution-user-props";
import { IClientDocumentCategoryDTO, IClientDocumentDTO } from "./models/response/client-document";
import { IClientDocumentCategoryRM, ICreateClientDocumentRM, IListClientDocumentRM, IUpdateClientDocumentRM } from "./models/request/client-document";
import { CommonHelper } from "src/utils/common-helper";
import { IVEDashboardEngagementAnalyticsCountRM, IVEDashboardChartDataRM, IVEDashboardUsersCountRM, IVEDashboardTopActiveUsersRM, IVEDashboardListAnalyticsRM, IVEDashboardAnalysisListReportRM } from "./models/request/ve-dashboard";
import { IVEDashboardUsersCountDTO, IVEDashboardEngagementAnalyticsCountDTO, IVEDashboardUsersAnalysisCountDTO, IVEDashboardAnalisysCreatedByNewAndReturningUsersCountDTO, IVEDashboardActiveUserDTO } from "./models/response/ve-dashboard";
import { INotificationDTO } from "./models/response/notification";
import { IPagedRM } from "./models/request/paged";
import { ISalesTriggerNewsDTO } from "./models/response/sales-trigger";
import { ICIAnalysis_CreateUpdateRM, ICIAnalysis_UpdateIndustryPeersRM, ICompanyInfo } from "./models/request/ci-analysis";
import { IAnalysisDTO } from "./models/response/analysis";
import {
    ICIAnalysis_KYC_CompanySnapshot_OutputStepData,
    ICIAnalysis_StepDTO,
    ICIAnalysis_IndustryPeer_InputStepData,
    ICIAnalysis_KYC_PrioritiesInitiatives_OutputStepData,
    ICIAnalysis_KYC_ChallengesRisks_OutputStepData,
    ICIAnalysis_KYC_Financials_OutputStepData,
    ICIAnalysis_KYC_News_OutputStepData,
    ICIAnalysis_ZOI_Trends_OutputStepData,
    ICIAnalysis_ZOI_CompetitorInsights_OutputStepData,
    ICIAnalysis_ZOI_CompanyPosition_OutputStepData,
    ICIAnalysis_BPS_PersonaAlignment_OutputStepData,
    ICIAnalysis_BPS_ExecutiveShareholdingSignals_OutputStepData,
    ICIAnalysis_BPS_OpportunityVsRoadblocks_OutputStepData,
    ICIOutput_BPS_SolutionPositioning_OutputStepData,
    ICIOther_ShortInsights_OutputStepData
} from "./models/response/ci-analysis";
import { IAIGenerateChatResponseRM, IAIGenerateTextRM } from "./models/request/ai-generate";
import { ICIDashboardAnalysisListReportRM, ICIDashboardChartDataRM, ICIDashboardEngagementAnalyticsCountRM, ICIDashboardListAnalyticsRM, ICIDashboardTopActiveUsersRM, ICIDashboardUsersCountRM } from "./models/request/ci-dashboard";
import { ICIDashboardActiveUserDTO, ICIDashboardAnalisysCreatedByNewAndReturningUsersCountDTO, ICIDashboardEngagementAnalyticsCountDTO, ICIDashboardUsersAnalysisCountDTO, ICIDashboardUsersCountDTO } from "./models/response/ci-dashboard";
import { ISummarizeNewsRM } from "./models/request/sales-triggers";
import { IAPIDataResult, IAPIResult } from "./models/response/api-result";

const axiosInstance = GetITBAxiosInstance();

//#region Auth
export const AuthenticateUserAPI = async (request: ILoginRM): Promise<IAPIDataResult<IAuthDTO>> => {
    return axiosInstance.post(API_ROUTE_SIGNIN, request);
};

export const AuthenticateTempUserAPI = async (token: string): Promise<IAPIDataResult<ITempAuthDTO>> => {
    return axiosInstance.get(API_ROUTE_SIGNIN_GUEST + "?t=" + token);
};

export const ChangePasswordAPI = async (request: IChangePasswordRM): Promise<IAPIDataResult<IAuthDTO>> => {
    return axiosInstance.post(API_ROUTE_CHNAGE_PASSWORD, request);
};

export const ForgotPasswordAPI = async (request: IForgotPasswordRM): Promise<IAPIDataResult<boolean>> => {
    return axiosInstance.post(API_ROUTE_FORGOT_PASSWORD, request);
};

export const ResetPasswordAPI = async (request: IResetPasswordRM): Promise<IAPIDataResult<boolean>> => {
    return axiosInstance.post(API_ROUTE_RESET_PASSWORD, request);
};

export const VerifyEmailsendOTPRequestAPI = async (email: string): Promise<IAPIDataResult<boolean>> => {
    let url = API_ROUTE_SELF_REGISTER_VERIFYEMAIL_SEND_OTP.replace('{email}', email);
    return axiosInstance.get(url);
};

export const VerifyEmailResendOTPRequestAPI = async (email: string): Promise<IAPIDataResult<boolean>> => {
    let url = API_ROUTE_SELF_REGISTER_VERIFYEMAIL_RESEND_OTP.replace('{email}', email);
    return axiosInstance.get(url);
};

export const VerifyOTPByEmailAPI = async (email: string, otp: string): Promise<IAPIDataResult<boolean>> => {
    let url = API_ROUTE_SELF_REGISTER_VERIFYEMAIL_BY_OTP
        .replace('{email}', email)
        .replace('{otp}', otp);
    return axiosInstance.get(url);
};

export const UpdateUserProfileAPI = async (request: any): Promise<IAPIDataResult<IUserDTO>> => {
    return axiosInstance.post(API_ROUTE_UPDATE_PROFILE, request, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export const GetCurrentUserAPI = async (): Promise<IAPIDataResult<IUserDTO>> => {
    return axiosInstance.get(API_ROUTE_GET_CURRENT_USER);
}
//#endregion

//#region Value Engine Analysis
export const ListVEAnalysisAPI = async (clientId?: string): Promise<IAPIDataResult<IAnalysisDTO[]>> => {
    let url;
    if (clientId && clientId.length > 0) {
        url = API_ROUTE_LIST_VE_ANALYSIS + '?clientid=' + clientId;
    } else {
        url = API_ROUTE_LIST_VE_ANALYSIS;
    }
    return axiosInstance.get(url);
};

export const ListVERecentAnalysisAPI = async (clientId: string): Promise<IAPIDataResult<IAnalysisDTO[]>> => {
    let url = API_ROUTE_LIST_VE_RECENT_ANALYSIS.replace('{clientId}', clientId);
    return axiosInstance.get(url);
};

export const CreateUpdateVEAnalysisAPI = (request: IVEAnalysis_CreateUpdateRM): Promise<IAPIDataResult<string>> => {
    return axiosInstance.post(API_ROUTE_VE_ANALYSIS_CREATE_UPDATE, request);
};

export const GetVEAnalysisByIdAPI = async (analysisId: string): Promise<IAPIDataResult<IAnalysisDTO>> => {
    let url = API_ROUTE_GET_VE_ANALYSIS_BY_ID
        .replace('{id}', analysisId);
    return axiosInstance.get(url);
};

export const ArchiveVEAnalysisAPI = async (analysisId: string): Promise<IAPIResult> => {
    let url = API_ROUTE_ARCHIVE_VE_ANALYSIS
        .replace('{id}', analysisId);
    return axiosInstance.delete(url);
};

export const VEAnalysis_BasicSetupAPI = async (request: IVEAnalysis_BasicSetupRM): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_VE_ANALYSIS_BASIC_SETUP, request);
};

export const VEAnalysis_ReadObjectsAPI = async (request: IVEAnalysis_ReadObjectsRM): Promise<IAPIDataResult<IValueCalculatorDataDTO>> => {
    return axiosInstance.post(API_ROUTE_VE_ANALYSIS_READ_OBJECTS, request);
};

export const VEAnalysis_WriteTableAPI = async (request: IVEAnalysis_WriteTableRM): Promise<IAPIDataResult<IValueCalculatorDataDTO>> => {
    return axiosInstance.post(API_ROUTE_VE_ANALYSIS_WRITE_TABLE, request);
};

export const VEAnalysis_WriteDataPointAPI = async (request: IVEAnalysis_WriteDataPointRM): Promise<IAPIDataResult<IValueCalculatorDataDTO>> => {
    return axiosInstance.post(API_ROUTE_VE_ANALYSIS_WRITE_DATAPOINT, request);
};

export const LogVEEventAPI = async (request: IVEAnalysis_LogEventRM): Promise<IAPIDataResult<IActivityHistoryDTO[]>> => {
    return axiosInstance.post(API_ROUTE_VE_ANALYSIS_LOG_EVENT, request);
};

export const VEAnalysis_ChangeStatusAPI = async (request: IVEAnalysis_ChangeStatusRM): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_VE_ANALYSIS_CHANGE_STATUS, request);
};

export const ListVEAnalysisDocsAPI = async (analysisId: string): Promise<IAPIDataResult<IVEAnalysis_DocumentDTO[]>> => {
    let url = API_ROUTE_LIST_VE_ANALYSIS_DOCS.replace('{id}', analysisId);
    return axiosInstance.get(url);
};

export const DownloadVEAnalysisDocumentAPI = async (documentId: string): Promise<any> => {
    return axiosInstance.get(API_ROUTE_VE_ANALYSIS_DOWNLOAD_DOCUMENT + documentId, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/octet-stream',
        },
    });
};

export const LinkShareVEAnalysisKeyInputsAPI = async (req: IVEAnalysis_LinkShareKeyInputsRM): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_VE_ANALYSIS_LINK_SHARE_KEYINPUTS, req);
};

export const DownloadVEAnalysisExcelDataCollectionAPI = async (req: IVEAnalysis_ExcelDownloadKeyInputsRM): Promise<any> => {
    return axiosInstance.post(API_ROUTE_VE_ANALYSIS_EXCEL_DOWNLOAD_KEYINPUTS, req, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            'Accept': '*/*',
        },
    });
};

export const UploadVEAnalysisExcelDataCollectionAPI = async (req: IVEAnalysis_ExcelUploadKeyInputsRM): Promise<IAPIResult> => {
    const frm = CommonHelper.jsonToFormData(req);
    return axiosInstance.post(API_ROUTE_VE_ANALYSIS_EXCEL_UPLOAD_KEYINPUTS, frm, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const ListVEAnalysisSharedKeyInputMetricsAPI = async (analysisId: string): Promise<IAPIDataResult<Array<IVEAnalysis_SharedMatricsDTO>>> => {
    return axiosInstance.get(API_ROUTE_VE_ANALYSIS_LIST_SHARED_KEYINPUT_METRICS + "?analysisid=" + analysisId);
};

export const ListVEAnalysisSharedKeyInputsAPI = async (shareId: string): Promise<IAPIDataResult<Array<IVEAnalysis_SharedTableDTO>>> => {
    return axiosInstance.get(API_ROUTE_VE_ANALYSIS_LIST_SHARED_KEYINPUTS + "?shareid=" + shareId);
};

export const WriteVEAnalysisSharedKeyInputsAPI = async (request: IVEAnalysis_WriteSharedKeyInputsRM): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_VE_ANALYSIS_WRITE_SHARED_KEYINPUTS, request);
};

export const SaveVEAnalysisClientProvidedMetricInputAPI = async (request: IVEAnalysis_SaveMetricBenchmarksRM): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_VE_ANALYSIS_SAVE_CLIENT_PROVIDED_METRIC_INPUT, request);
};

export const LinkShareVEAnalysisWholeAnalysisAPI = async (req: IVEAnalysis_LinkShareWholeAnalysisRM): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_VE_ANALYSIS_LINK_SHARE_WHOLE_ANALYSIS, req);
};

export const UpdateLinkShareVEAnalysisWholeAnalysisAPI = async (req: IVEAnalysis_UpdateLinkShareWholeAnalysisRM): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_VE_ANALYSIS_UPDATE_LINK_SHARE_WHOLE_ANALYSIS, req);
};

export const ListLinkSharesVEAnalysisAPI = async (analysisId: string, isWholeAnalysisOnly: boolean = true): Promise<IAPIDataResult<IValueEngineAnalysisLinkShareResultDTO[]>> => {
    return axiosInstance.get(API_ROUTE_VE_ANALYSIS_LIST_LINK_SHARES, {
        params: {
            analysisid: analysisId,
            wholeanalysisonly: isWholeAnalysisOnly ? "1" : "0"
        }
    });
};

export const GetLinkShareVEAnalysisAPI = async (): Promise<IAPIDataResult<IValueEngineAnalysisLinkShareDTO>> => {
    return axiosInstance.get(API_ROUTE_VE_ANALYSIS_GET_LINK_SHARE);
};

export const ListVEAnalysisVCModificationLogsAPI = async (req: IVEAnalysis_ViewTableModificationLogsRM): Promise<IAPIDataResult<Array<IVEAnalysis_VCModificationLogDTO>>> => {
    return axiosInstance.post(API_ROUTE_VE_ANALYSIS_LIST_VC_MODIFICATION_LOGS, req);
};
//#endregion

//#region Customer Insights Analysis
export const ListCICompanyTickersAPI = async (query: string): Promise<IAPIDataResult<ICompanyInfo[]>> => {
    return axiosInstance.get(API_ROUTE_LIST_CI_COMPANY_TICKERS + '?query=' + query);
};

export const ListCIAnalysisAPI = async (clientId?: string, limit: number = 0): Promise<IAPIDataResult<IAnalysisDTO[]>> => {
    let url;
    if (clientId && clientId.length > 0)
        url = API_ROUTE_LIST_CI_ANALYSIS + '?clientid=' + clientId + "&limit=" + limit;
    else
        url = API_ROUTE_LIST_CI_ANALYSIS + "?limit=" + limit;
    return axiosInstance.get(url);
};

export const GetCIAnalysisByIdAPI = async (analysisId: string): Promise<IAPIDataResult<IAnalysisDTO>> => {
    let url = API_ROUTE_GET_CI_ANALYSIS_BY_ID
        .replace('{id}', analysisId);
    return axiosInstance.get(url);
};

export const CreateUpdateCIAnalysisAPI = (request: ICIAnalysis_CreateUpdateRM): Promise<IAPIDataResult<string>> => {
    return axiosInstance.post(API_ROUTE_CI_ANALYSIS_CREATE_UPDATE, request);
};

export const GetCIAnalysisIndustryPeersAPI = (analysisId: string, forceRefresh: boolean = false): Promise<IAPIDataResult<ICIAnalysis_StepDTO<ICIAnalysis_IndustryPeer_InputStepData>>> => {
    return axiosInstance.get(API_ROUTE_CI_ANALYSIS_GET_INDUSTRY_PEERS, {
        params: {
            analysisid: analysisId,
            forcerefresh: forceRefresh ? "1" : "0"
        }
    });
};

export const SaveCIAnalysisIndustryPeersAPI = (request: ICIAnalysis_UpdateIndustryPeersRM): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_CI_ANALYSIS_SAVE_INDUSTRY_PEERS, request);
};

export const GetCIAnalysisKYCCompanySnapshotAPI = (analysisId: string, forceRefresh: boolean = false): Promise<IAPIDataResult<ICIAnalysis_StepDTO<ICIAnalysis_KYC_CompanySnapshot_OutputStepData>>> => {
    return axiosInstance.get(API_ROUTE_CI_ANALYSIS_GET_KYC_COMPANY_SNAPSHOT, {
        params: {
            analysisid: analysisId,
            forcerefresh: forceRefresh ? "1" : "0"
        }
    });
};

export const GetCIAnalysisKYCPrioritiesInitiativesAPI = (analysisId: string, forceRefresh: boolean = false): Promise<IAPIDataResult<ICIAnalysis_StepDTO<ICIAnalysis_KYC_PrioritiesInitiatives_OutputStepData>>> => {
    return axiosInstance.get(API_ROUTE_CI_ANALYSIS_GET_KYC_PRIORITIES_INITIATIVES, {
        params: {
            analysisid: analysisId,
            forcerefresh: forceRefresh ? "1" : "0"
        }
    });
};

export const GetCIAnalysisKYCChallengesRisksAPI = (analysisId: string, forceRefresh: boolean = false): Promise<IAPIDataResult<ICIAnalysis_StepDTO<Array<ICIAnalysis_KYC_ChallengesRisks_OutputStepData>>>> => {
    return axiosInstance.get(API_ROUTE_CI_ANALYSIS_GET_KYC_CHALLENGES_RISKS, {
        params: {
            analysisid: analysisId,
            forcerefresh: forceRefresh ? "1" : "0"
        }
    });
};

export const GetCIAnalysisKYCFinancialsAPI = (analysisId: string, forceRefresh: boolean = false): Promise<IAPIDataResult<ICIAnalysis_StepDTO<ICIAnalysis_KYC_Financials_OutputStepData>>> => {
    return axiosInstance.get(API_ROUTE_CI_ANALYSIS_GET_KYC_FINANCIALS, {
        params: {
            analysisid: analysisId,
            forcerefresh: forceRefresh ? "1" : "0"
        }
    });
};

export const GetCIAnalysisKYCNewsAPI = (analysisId: string, forceRefresh: boolean = false): Promise<IAPIDataResult<ICIAnalysis_StepDTO<ICIAnalysis_KYC_News_OutputStepData>>> => {
    return axiosInstance.get(API_ROUTE_CI_ANALYSIS_GET_KYC_NEWS, {
        params: {
            analysisid: analysisId,
            forcerefresh: forceRefresh ? "1" : "0"
        }
    });
};

export const GetCIAnalysisZOITrendsAPI = (analysisId: string, forceRefresh: boolean = false): Promise<IAPIDataResult<ICIAnalysis_StepDTO<ICIAnalysis_ZOI_Trends_OutputStepData>>> => {
    return axiosInstance.get(API_ROUTE_CI_ANALYSIS_GET_ZOI_TRENDS, {
        params: {
            analysisid: analysisId,
            forcerefresh: forceRefresh ? "1" : "0"
        }
    });
};

export const GetCIAnalysisZOICompetitorInsightsAPI = (analysisId: string, forceRefresh: boolean = false): Promise<IAPIDataResult<ICIAnalysis_StepDTO<ICIAnalysis_ZOI_CompetitorInsights_OutputStepData>>> => {
    return axiosInstance.get(API_ROUTE_CI_ANALYSIS_GET_ZOI_COMPETITOR_INSIGHTS, {
        params: {
            analysisid: analysisId,
            forcerefresh: forceRefresh ? "1" : "0"
        }
    });
};

export const GetCIAnalysisZOICompanyPositionAPI = (analysisId: string, forceRefresh: boolean = false): Promise<IAPIDataResult<ICIAnalysis_StepDTO<ICIAnalysis_ZOI_CompanyPosition_OutputStepData>>> => {
    return axiosInstance.get(API_ROUTE_CI_ANALYSIS_GET_ZOI_COMPANY_POSITION, {
        params: {
            analysisid: analysisId,
            forcerefresh: forceRefresh ? "1" : "0"
        }
    });
};

export const GetCIAnalysisBPSPersonaAlignmentAPI = (analysisId: string, forceRefresh: boolean = false): Promise<IAPIDataResult<ICIAnalysis_StepDTO<Array<ICIAnalysis_BPS_PersonaAlignment_OutputStepData>>>> => {
    return axiosInstance.get(API_ROUTE_CI_ANALYSIS_GET_BPS_PERSONA_ALIGNMENT, {
        params: {
            analysisid: analysisId,
            forcerefresh: forceRefresh ? "1" : "0"
        }
    });
};

export const GetCIAnalysisBPSExecutiveShareholderSignalsAPI = (analysisId: string, forceRefresh: boolean = false): Promise<IAPIDataResult<ICIAnalysis_StepDTO<Array<ICIAnalysis_BPS_ExecutiveShareholdingSignals_OutputStepData>>>> => {
    return axiosInstance.get(API_ROUTE_CI_ANALYSIS_GET_BPS_EXECUTIVE_SHAREHOLDER_SIGNALS, {
        params: {
            analysisid: analysisId,
            forcerefresh: forceRefresh ? "1" : "0"
        }
    });
};

export const GetCIAnalysisBPSOpportunityVsRoadblocksAPI = (analysisId: string, forceRefresh: boolean = false): Promise<IAPIDataResult<ICIAnalysis_StepDTO<ICIAnalysis_BPS_OpportunityVsRoadblocks_OutputStepData>>> => {
    return axiosInstance.get(API_ROUTE_CI_ANALYSIS_GET_BPS_OPPORTUNITY_VS_ROADBLOCKS, {
        params: {
            analysisid: analysisId,
            forcerefresh: forceRefresh ? "1" : "0"
        }
    });
};

export const GetCIAnalysisBPSSolutionPositioningAPI = (analysisId: string, forceRefresh: boolean = false): Promise<IAPIDataResult<ICIAnalysis_StepDTO<ICIOutput_BPS_SolutionPositioning_OutputStepData>>> => {
    return axiosInstance.get(API_ROUTE_CI_ANALYSIS_GET_BPS_SOLUTION_POSITIONING, {
        params: {
            analysisid: analysisId,
            forcerefresh: forceRefresh ? "1" : "0"
        }
    });
};

export const GetCIAnalysisShortInsightsAPI = (analysisId: string, forceRefresh: boolean = false): Promise<IAPIDataResult<ICIAnalysis_StepDTO<ICIOther_ShortInsights_OutputStepData>>> => {
    return axiosInstance.get(API_ROUTE_CI_ANALYSIS_GET_SHORT_INSIGHTS, {
        params: {
            analysisid: analysisId,
            forcerefresh: forceRefresh ? "1" : "0"
        }
    });
};

export const GenerateAITextAPI = (model: IAIGenerateTextRM, signal?: AbortSignal): Promise<IAPIDataResult<string>> => {
    return axiosInstance.post(API_ROUTE_AI_GENERATE_TEXT, model, { signal });
};

export const GenerateAIChatResponseAPI = (model: IAIGenerateChatResponseRM, signal?: AbortSignal): Promise<IAPIDataResult<string>> => {
    return axiosInstance.post(API_ROUTE_AI_GENERATE_CHAT_RESPONSE, model, { signal });
};
//#endregion

//#region Client
export const ListClientsAPI = async (request: IListClientsRM): Promise<IAPIDataResult<IPagedResultDTO<IClientDTO>>> => {
    return axiosInstance.post(API_ROUTE_LIST_CLIENTS, request);
};

export const CreateClientAPI = async (data: IClientRM): Promise<IAPIDataResult<any>> => {
    const form = CommonHelper.jsonToFormData(data);
    return axiosInstance.post(API_ROUTE_CREATE_CLIENT, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const DownloadClientsReportAPI = async (request: IDownloadClientsRM): Promise<any> => {
    return axiosInstance.post(API_ROUTE_EXPORT_CLIENT, request, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/octet-stream',
        },
    });
};

export const GetClientByIdAPI = async (id: string): Promise<IAPIDataResult<IClientDTO>> => {
    return axiosInstance.get(`${API_ROUTE_GET_CLIENT_BY_ID}${id}`);
};

export const GetClientPartialDetailsAPI = async (id: string): Promise<IAPIDataResult<IClientDTO>> => {
    let url = API_ROUTE_GET_PARTIALS_CLIENT_DETAILS.replace('{id}', id);
    return axiosInstance.get(url);
};

export const ListClientsIdNameDictionaryAPI = async (): Promise<IAPIDataResult<IClientDTO>> => {
    return axiosInstance.get(API_ROUTE_CLIENTS_IDNAMEDIC);
};

export const UpdateClientAPI = async (data: IClientRM): Promise<IAPIDataResult<any>> => {
    const form = CommonHelper.jsonToFormData(data);
    return axiosInstance.post(API_ROUTE_UPDATE_CLIENT, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const ChangeClientStatusAPI = async (request: IChangeStatusRM): Promise<IAPIDataResult<any>> => {
    return axiosInstance.post(API_ROUTE_CHANGE_CLIENT_STATUS, request);
};

export const CheckClientNameExistsAPI = async (name: string, clientid?: string): Promise<IAPIDataResult<boolean>> => {
    let url = API_ROUTE_CHECK_CLIENTNAME_EXIST
        .replace('{clientid}', clientid || '%20') + "?name=" + name;
    return axiosInstance.get(url);
};

export const CheckClientDomainExistsAPI = async (domain: string, clientid?: string): Promise<IAPIDataResult<boolean>> => {
    let url = API_ROUTE_CHECK_CLIENTDOMAIN_EXIST
        .replace('{domain}', domain || '%20')
        .replace('{clientid}', clientid || '%20');
    return axiosInstance.get(url);
};
//#endregion

//#region Client Documents
export const ListClientDocumentsAPI = async (req: IListClientDocumentRM): Promise<IAPIDataResult<IClientDocumentDTO[]>> => {
    return axiosInstance.post(API_ROUTE_LIST_CLIENT_DOCUMENTS, req);
};

export const CreateClientDocumentsAPI = async (rms: Array<ICreateClientDocumentRM>): Promise<IAPIResult> => {
    const formData = CommonHelper.jsonToFormData({ documents: rms });
    return axiosInstance.post(API_ROUTE_CREATE_CLIENT_DOCUMENTS, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const UpdateClientDocumentsAPI = async (rms: IUpdateClientDocumentRM): Promise<IAPIResult> => {
    const formData = CommonHelper.jsonToFormData(rms);
    return axiosInstance.post(API_ROUTE_UPDATE_CLIENT_DOCUMENTS, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const DeleteClientDocumentsAPI = async (documentId: string): Promise<IAPIResult> => {
    return axiosInstance.delete(API_ROUTE_DELETE_CLIENT_DOCUMENTS + `/${documentId}`);
};

export const ListClientDocumentCategoriesAPI = async (): Promise<IAPIDataResult<Array<IClientDocumentCategoryDTO>>> => {
    return axiosInstance.get(API_ROUTE_LIST_CLIENT_DOCUMENT_CATEGORIES);
};

export const SaveClientDocumentCategoriesAPI = async (rms: Array<IClientDocumentCategoryRM>): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_SAVE_CLIENT_DOCUMENT_CATEGORIES, rms);
};

export const DownloadClientDocumentAPI = async (documentPath: string, fileName: string): Promise<any> => {
    return axiosInstance.get(API_ROUTE_DOWNLOAD_CLIENT_DOCUMENT + "?path=" + documentPath + "&filename=" + fileName, {
        responseType: 'blob',
        headers: {
            'Accept': '*/*',
        },
    });
};
//#endregion

//#region Solution-User
export const ListSolutionUserPendingRequestsAPI = async (clientId: string, solutionId?: string): Promise<IAPIDataResult<IPendingRequestSolutionUserDTO[]>> => {
    let url = API_ROUTE_LIST_PENDING_SOLUTION_REQUESTS
        .replace('{clientId}', clientId)
        .replace('{solutionId}', solutionId ?? "");
    return axiosInstance.get(url);
};

export const ListSolutionAdminsAPI = async (clientId: string, solutionId?: string): Promise<IAPIDataResult<IManageUserDTO[]>> => {
    let url = API_ROUTE_LIST_SOLUTIONADMINS
        .replace('{clientId}', clientId)
        .replace('{solutionId}', solutionId ?? "");
    return axiosInstance.get(url);
};

export const ListSolutionUsersAPI = async (clientId: string, solutionId?: string): Promise<IAPIDataResult<IManageUserDTO[]>> => {
    let url = API_ROUTE_LIST_SOLUTIONUSER
        .replace('{clientId}', clientId)
        .replace('{solutionId}', solutionId ?? "");
    return axiosInstance.get(url);
};

export const ListSignedinOnlyUsersAPI = async (clientId: string): Promise<IAPIDataResult<IUserDTO[]>> => {
    let url = API_ROUTE_LIST_SIGNEDIN_ONLY_SOLUTIONUSERS
        .replace('{clientId}', clientId);
    return axiosInstance.get(url);
};

export const SelfRegisterSolutionUserAPI = async (request: ISelfRegisterSolutionUserRM): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_SELF_REGISTER_SOLUTIONUSER, request);
};

export const CreateSolutionUserAPI = async (request: ICreateAssignSolutionUserRM): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_CREATE_SOLUTION_USER, request);
};

export const AssignSolutionsAPI = async (request: ICreateAssignSolutionUserRM): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_ASSIGN_SOLUTIONACCESSES_TO_EXISTING_SOLUTIONUSER, request);
};

export const SendReminderToSignedInOnlyUsersAPI = async (userIds: string[]): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_SEND_REMINDERS_SIGNEDIN_ONLY_SOLUTIONUSERS, userIds);
};

export const ListExistingUserWithSolutionRolesAPI = async (clientId: string, email: string): Promise<IAPIDataResult<IExistingUserWithSolutionRoleDTO>> => {
    let url = API_ROUTE_LIST_SOLUTIONUSERROLES
        .replace('{clientId}', clientId)
        .replace('{email}', email);
    return axiosInstance.get(url);
};

export const TerminateSolutionUserAPI = async (request: ITerminateUserRM): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_TERMINATE_SOLUTIONUSER, request);
};

export const RevokeSolutionAccessAPI = async (request: IRevokeSolutionAccessRM): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_REVOKE_SOLUTION_ACCESS, request);
};

export const ListSolutionAccessAPI = async (Clientid: string): Promise<IAPIDataResult<ISolutionRoleDTO[]>> => {
    let url = API_ROUTE_LIST_SOLUTIONACCESS.replace('{clientId}', Clientid);
    return axiosInstance.post(url);
};

export const GenerateSolutionRequestsAPI = async (solutionIds: string[]): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_GENERATE_SOLUTION_REQUESTS, solutionIds);
};

export const ApproveSolutionUserRequestsAPI = async (request: any): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_APPROVE_SOLUTION_REQUESTS, request);
};

export const RejectSolutionUserRequestsAPI = async (request: IRejectRequestsRM): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_REJECT_SOLUTION_REQUESTS, request);
};

export const GetSolutionAccessListByClientAPI = async (clientId: string, emailId?: string): Promise<IAPIDataResult<ISolutionAccessControl>> => {
    let url = API_ROUTE_SOLUTIONUSER_ACCESS_LIST
        .replace('{clientId}', clientId);
    if (emailId && emailId.length > 0) {
        url = url + '?email=' + emailId;
    }

    return axiosInstance.get(url);
};

export const SolutionAccessManageAPI = async (request: ISolutionAccessControl): Promise<IAPIResult> => axiosInstance.post(API_ROUTE_SOLUTIONUSER_ACCESS_MANAGE, request);
//#endregion

//#region Solution
export const ListAllSolutionsAPI = async (clientid: string): Promise<IAPIDataResult<ISolutionDTO[]>> => {
    let url = API_ROUTE_LIST_ALL_SOLUTIONS.replace('{clientId}', clientid);
    return axiosInstance.get(url);
};

export const ListOwnSolutionsAPI = async (clientid: string): Promise<IAPIDataResult<ISolutionDTO[]>> => {
    let url = API_ROUTE_LIST_OWN_SOLUTIONS.replace('{clientId}', clientid);
    return axiosInstance.get(url);
};

export const ListOthersSolutionsAPI = async (clientid: string): Promise<IAPIDataResult<ISolutionDTO[]>> => {
    let url = API_ROUTE_LIST_OTHERS_SOLUTIONS.replace('{clientId}', clientid);
    return axiosInstance.get(url);
};

export const ListSolutionNameIdDicAPI = async (clientid: string): Promise<IAPIDataResult<any>> => {
    let url = API_ROUTE_LIST_SOLUTIONS_IDNAMEDIC_BY_CLIENTID.replace('{clientId}', clientid);
    return axiosInstance.get(url);
};

export const CreateSolutionAPI = async (request: ICreateSolutionRM): Promise<IAPIDataResult<string>> => {
    return axiosInstance.post(API_ROUTE_CREATE_SOLUTION, request);
};

export const GetSolutionByIdAPI = async (id: string): Promise<IAPIDataResult<ISolutionDTO>> => {
    let url = API_ROUTE_GET_SOLUTION_BY_ID.replace('{id}', id);
    return axiosInstance.get(url);
};

export const CheckSolutionNameExsitsAPI = async (clientId: string, solutionName: string, solutionId: string = ""): Promise<IAPIDataResult<boolean>> => {
    let url = API_ROUTE_CHECK_SOLUTIONNAME_EXISTS
        .replace('{clientId}', clientId)
        .replace('{solutionName}', solutionName)
        .replace('{solutionId}', solutionId);
    return axiosInstance.get(url);
};

export const ValidateVCFileAPI = async (file: File): Promise<IAPIDataResult<IVCFileValidationResultDTO>> => {
    const frm = new FormData();
    frm.append("file", file, file.name);
    return axiosInstance.post(API_ROUTE_VALIDATE_VCEXCEL_FILE, frm, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const GetRoleBaseSolutionConfigurationAPI = async (solutionId: string): Promise<IAPIDataResult<IRoleBasedSolutionConfigurationDTO[]>> => {
    let url = API_ROUTE_GET_ROLEBASE_SOLUTION_CONFIGURATIONS.replace('{solutionId}', solutionId);
    return axiosInstance.get(url);
};

export const DownloadSolutionDocumentAPI = async (documentId: string): Promise<any> => {
    return axiosInstance.get(API_ROUTE_SOLUTION_DOWNLOAD_DOCUMENT + documentId, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/octet-stream',
        },
    });
};

export const RestoreSolutionAPI = async (solutionId: string): Promise<IAPIResult> => {
    let url = API_ROUTE_SOLUTION_RESTORE.replace('{solutionId}', solutionId);
    return axiosInstance.get(url);
};

export const ActivateDeactivateSolutionAPI = async (request: IActivateDeactivateSolutionRM): Promise<IAPIDataResult<ICreateUpdateSolutionRM>> => {
    return axiosInstance.post(API_ROUTE_ACTIVATE_DEACTIVATED_SOLUTION, request);
};

export const ChangeSolutionStatusAPI = async (request: IChangeSolutionStatusRM): Promise<IAPIDataResult<ICreateUpdateSolutionRM>> => {
    return axiosInstance.post(API_ROUTE_CHANGE_SOLUTION_STATUS, request);
};

export const GetSolutionStep1_1DataAPI = async (solutionId: string): Promise<IAPIDataResult<ISolutionStep1_1>> => {
    return axiosInstance.get(API_ROUTE_GET_SOLUTION_STEP_1_1.replace("{solutionId}", solutionId));
};

export const SaveSolutionStep1_1DataAPI = async (data: ISolutionStep1_1): Promise<IAPIDataResult<boolean>> => {
    const form = CommonHelper.jsonToFormData(data);
    return axiosInstance.post(API_ROUTE_SAVE_SOLUTION_STEP_1_1, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const GetSolutionStep1_2DataAPI = async (solutionId: string): Promise<IAPIDataResult<ISolutionStep1_2>> => {
    return axiosInstance.get(API_ROUTE_GET_SOLUTION_STEP_1_2.replace("{solutionId}", solutionId));
};

export const SaveSolutionStep1_2DataAPI = async (data: ISolutionStep1_2): Promise<IAPIDataResult<boolean>> => {
    const form = CommonHelper.jsonToFormData(data);
    return axiosInstance.post(API_ROUTE_SAVE_SOLUTION_STEP_1_2, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const GetSolutionStep1_3DataAPI = async (solutionId: string): Promise<IAPIDataResult<ISolutionStep1_3 | null | undefined>> => {
    return axiosInstance.get(API_ROUTE_GET_SOLUTION_STEP_1_3.replace("{solutionId}", solutionId));
};

export const SaveSolutionStep1_3DataAPI = async (data: ISolutionStep1_3): Promise<IAPIDataResult<boolean>> => {
    return axiosInstance.post(API_ROUTE_SAVE_SOLUTION_STEP_1_3, data);
};

export const GetSolutionStep2DataAPI = async (solutionId: string): Promise<IAPIDataResult<ISolutionStep2>> => {
    return axiosInstance.get(API_ROUTE_GET_SOLUTION_STEP_2.replace("{solutionId}", solutionId));
};

export const SaveSolutionStep2API = async (request: ISolutionStep2): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_SAVE_SOLUTION_STEP_2, request);
};

export const GetSolutionStep3DataAPI = async (solutionId: string): Promise<IAPIDataResult<ISolutionStep3>> => {
    return axiosInstance.get(API_ROUTE_GET_SOLUTION_STEP_3.replace("{solutionId}", solutionId));
};
export const SaveSolutionStep3API = async (request: ISolutionStep3): Promise<IAPIResult> => {
    return axiosInstance.post(API_ROUTE_SAVE_SOLUTION_STEP_3, request);
};

export const GetSolutionStep4DataAPI = async (solutionId: string): Promise<IAPIDataResult<ISolutionStep4>> => {
    return axiosInstance.get(API_ROUTE_GET_SOLUTION_STEP_4.replace("{solutionId}", solutionId));
};

export const GetSolutionStep5DataAPI = async (solutionId: string): Promise<IAPIDataResult<ISolutionStep5>> => {
    return axiosInstance.get(API_ROUTE_GET_SOLUTION_STEP_5.replace("{solutionId}", solutionId));
};

export const SaveSolutionStep4DataAPI = async (data: ISolutionStep4): Promise<IAPIDataResult<boolean>> => {
    const form = CommonHelper.jsonToFormData(data);
    return axiosInstance.post(API_ROUTE_SAVE_SOLUTION_STEP_4, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const SaveSolutionStep5DataAPI = async (data: ISolutionStep5): Promise<IAPIDataResult<boolean>> => {
    const form = CommonHelper.jsonToFormData(data);
    return axiosInstance.post(API_ROUTE_SAVE_SOLUTION_STEP_5, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};
//#endregion

//#region User
export const ListITBAdminsAPI = async (): Promise<IAPIDataResult<IUserDTO[]>> => axiosInstance.get(API_ROUTE_LIST_ITB_ADMINS);

export const CreateITBAdminAPI = async (formData: ICreateITBAdminRM): Promise<IAPIDataResult<any>> => {
    return axiosInstance.post(API_ROUTE_CREATE_ITB_ADMIN, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const TerminateITBAdminAPI = async (request: ITerminateUserRM): Promise<IAPIDataResult<void>> => {
    return axiosInstance.post(API_ROUTE_TERMINATE_ITB_ADMIN, request);
};

export const ReActiveITBAdminAPI = async (request: ITerminateUserRM): Promise<IAPIDataResult<void>> => {
    return axiosInstance.post(API_ROUTE_REACTIVE_ITB_ADMIN, request);
};

export const CheckUserEmailExistsAPI = async (email: string): Promise<IAPIDataResult<boolean>> => {
    let url = API_ROUTE_CHECK_EMAIL_EXIST.replace('{email}', email);
    return axiosInstance.get<IAPIDataResult<boolean>, any>(url);
};

export const GetUserByIdAPI = async (id: string): Promise<IAPIDataResult<IUserDTO>> => {
    const url = API_ROUTE_GET_USER_BY_ID.replace('{id}', id);
    return axiosInstance.get<IAPIDataResult<IUserDTO>, any>(url);
};

export const UpdateITBAdminAPI = async (request: IUpdateITBAdminRM): Promise<IAPIDataResult<any>> => {
    return axiosInstance.post(API_ROUTE_UPDATE_ITB_ADMIN, request);
};

export const ListActivityHistoryAPI = async (): Promise<IAPIDataResult<IActivityHistoryDTO[]>> => axiosInstance.get<IAPIDataResult<IActivityHistoryDTO[]>, any>(API_ROUTE_LIST_ACTIVITY_HISTORY);
//#endregion

//#region SupportCase
export const ListSupportCasesAPI = async (clientId?: string | null): Promise<IAPIDataResult<ISupportCaseDTO[]>> => {
    let url;
    if (clientId && clientId.length > 0)
        url = API_ROUTE_LIST_SUPPORTCASE + '?clientid=' + clientId;
    else
        url = API_ROUTE_LIST_SUPPORTCASE;
    return axiosInstance.get(url);
}

export const CreateSupportCaseAPI = async (data: IGenerateNewSupportCaseRM): Promise<IAPIDataResult<any>> => {
    const form = CommonHelper.jsonToFormData(data);
    return axiosInstance.post(API_ROUTE_CREATE_SUPPORTCASE, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const UpdateSupportCaseAPI = async (data: IUpdateSupportCaseRM): Promise<IAPIDataResult<any>> => {
    const form = CommonHelper.jsonToFormData(data);
    return axiosInstance.post(API_ROUTE_UPDATE_SUPPORTCASE, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const ResolveSupportCaseAPI = async (request: IResolveSupportCaseRM): Promise<IAPIDataResult<any>> => {
    return axiosInstance.post(API_ROUTE_RESOLVE_SUPPORTCASE, request);
};

export const DownloadSupportCaseReportAPI = async (request: IDownloadSuportCaseRM): Promise<any> => {
    return axiosInstance.post(API_ROUTE_EXPORT_SUPPORTCASE, request, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/octet-stream',
        },
    });
};

export const DownloadSupportCaseDocumentAPI = async (documentId: string): Promise<any> => {
    return axiosInstance.get(API_ROUTE_SUPPORT_CASE_DOWNLOAD_ATTACHMENT + documentId, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            'Accept': '*/*',
        },
    });
};
//#endregion

//#region Dashboard
export const GetVEDashboardUsersCountAPI = async (request: IVEDashboardUsersCountRM): Promise<IAPIDataResult<IVEDashboardUsersCountDTO>> => {
    return axiosInstance.post(API_ROUTE_VE_DASHBOARD_USERS_COUNT, request);
};

export const GetVEDashboardEngagementAnalyticsCountAPI = async (request: IVEDashboardEngagementAnalyticsCountRM): Promise<IAPIDataResult<IVEDashboardEngagementAnalyticsCountDTO>> => {
    return axiosInstance.post(API_ROUTE_VE_DASHBOARD_ENGAGEMENT_ANALYTICS_COUNT, request);
};

export const GetVEDashboardChartUsersAnalysisAPI = async (request: IVEDashboardChartDataRM): Promise<IAPIDataResult<IVEDashboardUsersAnalysisCountDTO[]>> => {
    return axiosInstance.post(API_ROUTE_VE_DASHBOARD_USERS_VS_ANALYSIS_COUNT, request);
};

export const GetVEDashboardChartAnalisysCreatedByNewAndReturningUsersAPI = async (request: IVEDashboardChartDataRM): Promise<IAPIDataResult<IVEDashboardAnalisysCreatedByNewAndReturningUsersCountDTO[]>> => {
    return axiosInstance.post(API_ROUTE_VE_DASHBOARD_CHART_ANALYSIS_CREATED_BY_NEW_VS_RETURNING_USERS, request);
};

export const GetVEDashboardTopActiveUsersAPI = async (request: IVEDashboardTopActiveUsersRM): Promise<IAPIDataResult<IVEDashboardActiveUserDTO[]>> => {
    return axiosInstance.post(API_ROUTE_VE_DASHBOARD_LIST_TOP_ACTIVE_USERS, request);
};

export const GetVEDashboardListAnalysisAPI = async (request: IVEDashboardListAnalyticsRM): Promise<IAPIDataResult<IAnalysisDTO[]>> => {
    return axiosInstance.post(API_ROUTE_VE_DASHBOARD_LIST_ANALYSIS, request);
};

export const GetVEDashboardReportAnalysisAPI = async (request: IVEDashboardAnalysisListReportRM): Promise<any> => {
    return axiosInstance.post(API_ROUTE_VE_DASHBOARD_REPORT_ANALYSIS, request, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            'Accept': '*/*',
        },
    });
};

export const GetCIDashboardUsersCountAPI = async (request: ICIDashboardUsersCountRM): Promise<IAPIDataResult<ICIDashboardUsersCountDTO>> => {
    return axiosInstance.post(API_ROUTE_CI_DASHBOARD_USERS_COUNT, request);
};

export const GetCIDashboardEngagementAnalyticsCountAPI = async (request: ICIDashboardEngagementAnalyticsCountRM): Promise<IAPIDataResult<ICIDashboardEngagementAnalyticsCountDTO>> => {
    return axiosInstance.post(API_ROUTE_CI_DASHBOARD_ENGAGEMENT_ANALYTICS_COUNT, request);
};

export const GetCIDashboardChartUsersAnalysisAPI = async (request: ICIDashboardChartDataRM): Promise<IAPIDataResult<ICIDashboardUsersAnalysisCountDTO[]>> => {
    return axiosInstance.post(API_ROUTE_CI_DASHBOARD_USERS_VS_ANALYSIS_COUNT, request);
};

export const GetCIDashboardChartAnalisysCreatedByNewAndReturningUsersAPI = async (request: ICIDashboardChartDataRM): Promise<IAPIDataResult<ICIDashboardAnalisysCreatedByNewAndReturningUsersCountDTO[]>> => {
    return axiosInstance.post(API_ROUTE_CI_DASHBOARD_CHART_ANALYSIS_CREATED_BY_NEW_VS_RETURNING_USERS, request);
};

export const GetCIDashboardTopActiveUsersAPI = async (request: ICIDashboardTopActiveUsersRM): Promise<IAPIDataResult<ICIDashboardActiveUserDTO[]>> => {
    return axiosInstance.post(API_ROUTE_CI_DASHBOARD_LIST_TOP_ACTIVE_USERS, request);
};

export const GetCIDashboardListAnalysisAPI = async (request: ICIDashboardListAnalyticsRM): Promise<IAPIDataResult<IAnalysisDTO[]>> => {
    return axiosInstance.post(API_ROUTE_CI_DASHBOARD_LIST_ANALYSIS, request);
};

export const GetCIDashboardReportAnalysisAPI = async (request: ICIDashboardAnalysisListReportRM): Promise<any> => {
    return axiosInstance.post(API_ROUTE_CI_DASHBOARD_REPORT_ANALYSIS, request, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            'Accept': '*/*',
        },
    });
};
//#endregion

//#region Notifications
export const ListPagedNotificationsAPI = async (request: IPagedRM): Promise<IAPIDataResult<IPagedResultDTO<INotificationDTO>>> => axiosInstance.post(API_ROUTE_LIST_PAGED_NOTIFICATIONS, request);
//#endregion

//#region SalesTrigger
export const ListSalesTriggerNewsAPI = async (maxNews: number = 5, analysisPeriodMonths = 3): Promise<IAPIDataResult<ISalesTriggerNewsDTO[]>> => {
    let url = API_ROUTE_LIST_SALES_TRIGGER_NEWS
        .replace('{maxnews}', maxNews > 0 ? maxNews.toString() : "5")
        .replace('{analysisperiodmonths}', analysisPeriodMonths > 0 ? analysisPeriodMonths.toString() : "3")
    return axiosInstance.get(url);
}

export const SummarizeSalesTriggerNewsAPI = async (model: ISummarizeNewsRM): Promise<IAPIDataResult<string[]>> => {
    return axiosInstance.post(API_ROUTE_SUMMARIZE_SALES_TRIGGER_NEWS, model);
}
//#endregion